/** API error codes (responseStatus.errorCode) the UI handles specifically. */
export const SWAP_REQUIRES_ASSISTANCE = "SWAP_REQUIRES_ASSISTANCE";
